import { removeCheckoutIdFromLocalStorage } from '../services/cartCheckoutService/checkout.service.helper'
import { removeCartIdFromLocalStorage } from '../services/cartService/cart.service.helper'

export function clearCartStorage(): void {
  removeCheckoutIdFromLocalStorage()
  removeCartIdFromLocalStorage()
}
